// @flow

import React, { type Node, useEffect } from 'react';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { Empty } from './empty';
import { fingerprint } from '@tectonics/prs/fingerprint';

export function SetFingerprintValue(): Node {
  const [, setFingerprintUser] = useUserInputValue('fingerprintUser');
  const incomingPayment = useIncomingPayment();

  useEffect(() => {
    if (incomingPayment) {
      const getFingerprint = async () => {
        return await fingerprint(incomingPayment);
      };
      getFingerprint().then(value => {
        if (typeof value === 'string') {
          setFingerprintUser(value);
        }
      });
    }
  }, [incomingPayment]);

  return <Empty />;
}
